import { EmptyState } from './EmptyState';
import { Panel } from './Panel';

/** A box for a tab that is not built yet */
export const ComingSoonPanel = ({ title }: { title: string }) => (
  <Panel title={title}>
    <EmptyState>This tab is coming soon.</EmptyState>
  </Panel>
);
